import { Editor as DraftJSEditor } from 'draft-js'
import { ComponentProps, FC, useContext } from 'react'
import { EditorContext } from '../EditorContext'
import { useInput } from '../hooks'
import { Root } from '../primatives'
import { InputProps } from '../types/input'

type InputElementProps = Omit<ComponentProps<typeof Root.Input>, 'onChange' | 'onError'>

export const EditorInput: FC<InputProps & InputElementProps> = ({
  maxPlainTextLength,
  placeholder,
  lineClamp,
  name,
  required,
  isDisabled,
  onChange,
  onError,
  ...rest
}) => {
  const { editorState, handleBeforeInput, handleChange, handlePastedText, handleBlur } = useInput({
    name,
    maxPlainTextLength,
    required,
    onChange,
    onError
  })
  const { dark } = useContext(EditorContext)

  return (
    <Root.Input {...rest} lineClamp={lineClamp} dark={dark} disabled={isDisabled}>
      <DraftJSEditor
        editorState={editorState}
        handleBeforeInput={handleBeforeInput}
        onChange={handleChange}
        placeholder={placeholder}
        handlePastedText={handlePastedText}
        onBlur={handleBlur}
        readOnly={isDisabled}
      />
    </Root.Input>
  )
}
